import React, { useEffect, useState }  from 'react'
import { useTranslation } from 'react-i18next'
import useUrlParams from 'hooks/useUrlParams'
import ChipButton from 'components/ChipButton'
import IconClose from 'components/partials/IconClose'

function FacetsTags({ facets = [] }) {
  const { t } = useTranslation()
  const { urlParams, updateUrlParams, replaceUrlParams } = useUrlParams()
  const [facetsApplied, setFacetsApplied] = useState([])
  const tagsOrder = ['date_from', 'date_to'].concat(facets.map(f => f.id))

  useEffect(() => {
    const facetsAppliedArray = Object.entries(urlParams)
      .filter(([facetName]) => 
         tagsOrder.indexOf(facetName) > -1 // filter out url params that are not facets
      )
      .reduce((acc, [facetName, facetValues]) => {
        [].concat(facetValues).forEach(value => acc.push([facetName, value])) // extract all values from from param=[1,3,7]
        return acc
      }, [])
      .sort(([aFacetName], [bFacetName]) => 
         tagsOrder.indexOf(aFacetName) - tagsOrder.indexOf(bFacetName) // sort accordingly to facets order
      )

    setFacetsApplied(facetsAppliedArray)
  }, [urlParams])

  const handleRemove = ([removeName, removeValue]) => {
    const currentValues = urlParams[removeName]
    const newValues = [].concat(currentValues).filter(value => value !== removeValue)
    const updateParams = { [removeName]: newValues }
    updateUrlParams(updateParams)
  }
  const handleClear = () => {
    const keepParams = ['q', 'sort', 'searcher', 'hits', 'offset']
    const newUrlParams = keepParams.reduce((acc, cur) => (acc[cur] = urlParams[cur], acc), {})
    replaceUrlParams(newUrlParams)
  }

  const facetDisplayName = ([facetName, facetValue]) => {
    const facetPrefix = {
      date_from: t('From'),
      date_to: t('To'),
    }[facetName] || ''

    return `${facetPrefix} ${facetValue}`.trim()
  }

  return Boolean(facetsApplied.length) && (
    <div className="columns small-12 medium-8 u-pl-0 u-mb-100 u-mb-0-medium-up u-mt-100-medium-up">
      <div className="u-flex">
        <div className="shrink">
          <div className="label u-inline-flex u-mt-100 u-mr-50">
            {t('Filtered by')}
          </div>
        </div>
        <div>
          {facetsApplied.map(facetNameAndValue => (
            <ChipButton
              modifierClasses="u-mr-50 u-mt-50 is-active"
              label={facetDisplayName(facetNameAndValue)}
              onClick={() => handleRemove(facetNameAndValue)}
              icon={<IconClose />}
            />
          ))}

          <button
            className="button button--tiny button--ghost-primary u-font-weight-700 u-mt-50"
            onClick={handleClear}
          >
            {t('Clear all filters')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default FacetsTags
